<template>
  <div
    @click="handleClick(false)"
    :id="`popup-box-${idx}`"
    :class="['panel-primary panel-chat', { opened: isOpen }, { expanded: isExpanded }]"
    :style="`right: ${rightPos}px`"
    :data-testid="author"
  >
    <div :class="['panel-heading', { flashit: hasNew }]">
      <span class="chat-minimize">
        <span class="glyphicon glyphicon-comment mr-5"></span> {{ author }}</span
      >
      <span
        v-on:keyup.enter="$event.target.click()"
        tabindex="0"
        @click="$emit('close', author)"
        class="chat-close"
        data-testid="chat-close-btn"
        ><i class="glyphicon glyphicon-remove"></i
      ></span>
      <span
        v-on:keyup.enter="$event.target.click()"
        tabindex="0"
        @click="$emit('minimize', author)"
        class="chat-close mr-10"
        ><i :class="['glyphicon', isOpen ? 'glyphicon-minus' : 'glyphicon-chevron-up']"></i
      ></span>
      <span v-if="isOpen" tabindex="0" @click="$emit('resize', author)" class="chat-close mr-10"
        ><i :class="['glyphicon', resizeIconClass]"></i
      ></span>
    </div>
    <div class="panel-body" :id="`chat-${idx}`">
      <template v-for="(message, i) in messages">
        <template v-if="displayMessage[message.questionKey]">
          <div class="clearfix" :key="`message-${i}`">
            <blockquote class="message m-15 p-10" v-html="message.descriptionTagKey"></blockquote>
            <template v-if="message.writtenResponse">
              <blockquote class="me message m-15 p-10">
                <div v-html="message.writtenResponse"></div>
              </blockquote>
            </template>
            <template v-else-if="message.answer">
              <blockquote class="me message m-15 p-10">
                <template v-for="answer in message.answer">
                  <div v-html="answer.nameTagKey" :key="`answer-${answer.answerkey}`"></div>
                </template>
              </blockquote>
            </template>
          </div>
        </template>
      </template>
    </div>
    <div v-if="needsAnswer" class="panel-footer">
      <!-- Multi answer question -->
      <template v-if="needsAnswer.FK_questionTypeKey === 3">
        <label for="written-response"></label>
        <textarea
          class="form-control written-response mb-10"
          id="written-response"
          v-model="writtenResponse"
        ></textarea>
      </template>
      <template v-else-if="needsAnswer.FK_questionTypeKey == 2">
        <template v-for="answer in needsAnswer.answers">
          <div class="radio multi-select-radio-layout">
            <label :for="`f-option-${answer.answerKey}`">
              <input
                name="answer"
                :id="`f-option-${answer.answerKey}`"
                type="checkbox"
                :value="answer.answerKey"
                v-model="picked"
              />
              <div class="multi-select-ans-option" v-html="answer.nameTagKey"></div>
            </label>
          </div>
        </template>
      </template>
      <!-- Single answer question -->
      <template v-else>
        <template v-for="answer in needsAnswer.answers">
          <div class="radio">
            <label :for="`f-option-${answer.answerKey}`">
              <input
                :name="`answer`"
                :id="`f-option-${answer.answerKey}`"
                type="radio"
                :value="answer.answerKey"
                v-model="picked"
              />
              <div v-html="answer.nameTagKey"></div>
            </label>
          </div>
        </template>
      </template>
      <button
        @click="submitAnswer"
        :disabled="!hasValidAnswer"
        class="btn btn-default mat btn-block"
      >
        Reply
      </button>
    </div>
  </div>
</template>
<script>
  import delay from 'lodash/delay';
  import radioButton from '../inputs/radio.vue';
  export default {
    name: 'chat-box',

    props: {
      idx: {
        type: Number,
        required: true,
      },

      messages: {
        type: Array,
        required: true,
      },

      author: {
        type: String,
        required: true,
      },
      rightPos: {
        type: Number,
        required: true,
      },

      isOpen: {
        type: Boolean,
        required: true,
      },

      isExpanded: {
        type: Boolean,
        required: true,
      },
      hasNew: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      picked: [],
      writtenResponse: '',
    }),

    components: {
      radioButton,
    },

    computed: {
      hasValidAnswer() {
        if (this.needsAnswer.FK_questionTypeKey === 3) {
          return !!this.writtenResponse.length;
        }
        return Array.isArray(this.picked) ? !!this.picked.length : true;
      },

      needsAnswer() {
        return this.messages.find(
          (message) => message.answers.length > 0 && message.answer === undefined
        );
      },

      displayMessage() {
        let isPreviousMessageAnswered = true;
        let retVal = {};
        this.messages.forEach((message) => {
          retVal[message.questionKey] = isPreviousMessageAnswered;
          isPreviousMessageAnswered =
            message.hasOwnProperty('answer') || message.answers.length == 0;
        });
        return retVal;
      },

      resizeIconClass() {
        return this.isExpanded ? 'glyphicon-resize-small' : 'glyphicon-fullscreen';
      },
    },

    mounted() {
      this.scroll(this.idx);
    },

    watch: {
      messages(val, oldVal) {
        if (val.length > oldVal.length) {
          if (!this.isOpen) this.$emit('minimize', this.author);
          this.scroll(this.idx);
        }
      },
    },

    methods: {
      handleClick() {
        this.$store.commit(
          'chat/SET_IS_READ',
          this.messages.map((m) => m.questionKey)
        );
        this.$emit('click');
      },

      //scroll to bottom of chat box when new messages are delivered
      scroll(i) {
        delay(function () {
          $(`#chat-${i}`).scrollTop($(`#chat-${i}`)[0].scrollHeight);
        }, 500);
      },

      submitAnswer() {
        if (this.hasValidAnswer) {
          //This entire section needs to be refactored
          const tempQuestionKey = this.needsAnswer.questionKey;

          const { FK_questionTypeKey, answers } = this.needsAnswer;

          const answerkey = FK_questionTypeKey === 3 ? answers[0].answerKey : this.picked;

          this.$store
            .dispatch('chat/ANSWER_MESSAGE', {
              questionkey: this.needsAnswer.questionKey,
              answerkey,
              isMessage: true,
              writtenResponse: this.writtenResponse,
            })
            .then(() => {
              this.picked = [];
              this.writtenResponse = '';
              this.scroll(this.idx);

              // Time bonus logic
              const question = this.$store.state.messages.find(
                (question) => question.questionKey === tempQuestionKey
              );
              if (question) {
                const { FK_questionTypeKey } = question;

                let answers;
                if (FK_questionTypeKey === 3) {
                  answers = [question.answers[0].answerKey];
                } else if (typeof this.picked === 'object') {
                  answers = this.picked;
                } else {
                  answers = [this.picked];
                }

                let questionAnswers = question.answers.filter((answer) =>
                  answers.includes(answer.answerKey)
                );
                let timeImpact = 0;
                questionAnswers.forEach((answer) => {
                  timeImpact += answer.timeImpact;
                });
                if (timeImpact != 0) this.$store.commit('time/UPDATE_DEADLINE', timeImpact);
              }
            });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .multi-select-radio-layout {
    margin-left: -10px;
  }
  .multi-select-ans-option {
    margin-top: -20px;
    margin-left: 20px;
  }
  input[type='radio'] {
    margin-top: 2px;
  }

  .panel-chat {
    position: fixed;
    display: flex;
    flex-direction: column;
    bottom: 0;
    right: 0;
    width: 280px;
    box-shadow: none;
    -webkit-box-shadow: none;
    margin-bottom: 0px;
    z-index: 51;

    -webkit-transition: all 0.6s;
    -moz-transition: all 0.6s;
    -ms-transition: all 0.6s;
    -o-transition: all 0.6s;
    transition: all 0.6s;

    &.opened {
      max-height: 90vh;
      .panel-body {
        height: 330px;
      }
      .panel-footer {
        display: block;
      }
      &.expanded {
        height: 90vh;
      }
      &.expanded .panel-body {
        flex-grow: 3;
      }
    }
    &.expanded {
      width: 500px;
    }

    .panel-heading {
      background-color: #1b222c;
      border-color: #1b222c;

      &.flashit {
        -webkit-animation: flash linear 1.2s infinite;
        animation: flash linear 1.2s infinite;
      }

      @-webkit-keyframes flash {
        0% {
          background-color: #1b222c;
        }
        50% {
          background-color: #23bd40;
        }
        100% {
          background-color: #1b222c;
        }
      }

      @keyframes flash {
        0% {
          background-color: #1b222c;
        }
        50% {
          background-color: #23bd40;
        }
        100% {
          background-color: #1b222c;
        }
      }
    }

    .panel-body {
      display: block;
      padding: 0;
      margin: 0;
      height: 0px;
      border-left: 1px solid #b2b2b2;
      border-right: 1px solid #b2b2b2;
      background: #edeff4;
      overflow: auto;
      -webkit-transition: height 0.6s;
      -moz-transition: height 0.6s;
      -ms-transition: height 0.6s;
      -o-transition: height 0.6s;
      transition: height 0.6s;

      .message {
        background-color: #fed986;
        border-radius: 4px;
        width: 89%;
        position: relative;
        font-size: 1.2rem;
        border-left: none;
        color: #333;
        font-size: 12px;

        &.me {
          float: right;
          background-color: #90d1bc;
          color: #000;
          &:after {
            right: -6px;
            border-right-color: #90d1bc;
          }
        }
        &:not(.me) {
          &:after {
            left: -6px;
          }
        }
        &:after {
          right: 100%;
          top: 10px;
          border: solid transparent;
          content: '';
          height: 0;
          width: 0;
          -ms-transform: rotate(-90deg);
          -webkit-transform: rotate(-90deg);
          transform: rotate(-90deg);
          position: absolute;
          z-index: 50;
          pointer-events: none;
          border-color: rgba(238, 238, 238, 0);
          border-right-color: #fed986;
          border-width: 10px;
          margin-top: -10px;
        }
      }
    }

    .panel-footer {
      border-left: 1px solid #b2b2b2;
      border-right: 1px solid #b2b2b2;
      display: none;
      color: #333;
      -webkit-transition: display 0.6s;
      -moz-transition: display 0.6s;
      -ms-transition: display 0.6s;
      -o-transition: display 0.6s;
      transition: display 0.6s;

      .radio {
        font-size: 1.2rem;
      }

      .written-response {
        padding: 7px;
        resize: none;
        width: 100%;
      }
    }

    .chat-minimize {
      cursor: default;
      width: 290px;
      color: #fff;
      font-weight: bold;
    }

    .chat-close {
      cursor: pointer;
      max-width: 10px;
      width: 10px;
      color: #fff;
      float: right;
    }
  }
</style>
